import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectDifferentLocations =
    createFeatureSelector<any>('differentLocations');

export const selectDifferentLocationsState = createSelector(
    selectDifferentLocations,
    (state: any) => state,
);
